import React, { useRef, lazy } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { ScrollReveal } from './ScrollReveal';
export const Environment = () => {
  const ref = useRef(null);
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start end', 'end start']
  });
  const yText = useTransform(scrollYProgress, [0, 1], ['0%', '10%']);
  const yImage = useTransform(scrollYProgress, [0, 1], ['0%', '-15%']);
  const points = ['la tolérance de votre peau', 'votre confort pendant la séance', 'la sécurité de chaque application laser', 'la transparence sur les résultats'];
  return;
};